import { useLocation } from "react-router-dom";

import type { Lead } from "common/types";

export function useNewConversation() {
  const { state }: { state?: { lead: Lead; accountId: string } } =
    useLocation();

  return {
    newConversation: state
      ? { participant: state.lead, owner: state.accountId }
      : undefined,
  };
}
